const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/eCheckin/ECheckinForm.tsx';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import PersAngaben from 'App/config/zgks/eCheckin/sections/PersAngaben';
import textMap from 'App/config/zgks/eCheckin/translations';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import Hausarzt from 'App/config/zgks/eCheckin/sections/Hausarzt';
import EinwArzt from 'App/config/zgks/eCheckin/sections/EinwArzt';
import Versicherung from 'App/config/zgks/eCheckin/sections/Versicherung';
import KontaktPerson from 'App/config/zgks/eCheckin/sections/KontaktPerson';
import PatientInfo from 'App/config/zgks/eCheckin/sections/PatientInfo';
import Finalize from 'App/components/eCheckin/components/sections/Finalize';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';
import {
    SECTION_PATH_EINWARZT,
    SECTION_PATH_HAUSARZT,
    SECTION_PATH_KONTAKT,
    SECTION_PATH_PERS_ANGABEN,
} from 'App/config/zgks/eCheckin/constants';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path={SECTION_PATH_PERS_ANGABEN} title={textMap.persAngaben} />
            <Hausarzt path={SECTION_PATH_HAUSARZT} title={textMap.hausArzt} />
            <EinwArzt path={SECTION_PATH_EINWARZT} title={textMap.einwArzt} />
            <Versicherung path="versicherung" title={textMap.versicherungLabel} />
            <KontaktPerson path={SECTION_PATH_KONTAKT} title={textMap.kontakt} />
            <PatientInfo path="patInfo" title={textMap.patInfo} />
            <Finalize path="finalize" />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
